export default {
  inject: {
    $buttonOwner: {
      default: null
    },
    $isPreView: {
      default: false
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: true
    },
    isButtonBar: {
      type: Boolean,
      default: true
    },
    buttons: {
      type: Array,
      default() {
        return [];
      }
    },
    size: {
      type: String,
      default: "auto"
    },
    align: {
      type: String,
      default: "center"
    },
    emitPrefix: {
      type: String,
      default: ""
    },
    renderButton: {
      type: Function,
      default: null
    },
    disabledButton: {
      type: Function,
      default: null
    },
    maxNumber: {
      type: Number,
      default: 2
    },
    moreButtonStyle: {
      type: String,
      default: ""
    },
    moreButtonText: {
      type: String,
      default: "更多"
    },
    isAllSelected: {
      type: Boolean,
      default: false
    },
    //按钮所在列表的行scope，用于列表，子表传递el-table的行scope参数
    slotScopeData: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  data() {
    return {
      client: "pc",
      buttonHandler: null,
      sPID: null,
      sCurNodeID: null,
      sCurLinkID: null,
      hasFlowLinkSend: false
    };
  },
  computed: {
    owner() {
      return this.$buttonOwner;
    },
    realSize() {
      let childFormItemSize = this.$page?.childFormItemSize || "normal";
      let size = this.size || "auto";
      return size == "auto" ? childFormItemSize : size;
    }
  },
  created() {
    if (!this.isDesign) {
      let data;
      if (this.$vm?.$dialog?.dialogArgs?.data) {
        data = this.$vm.$dialog.dialogArgs.data[0];
      }
      this.sPID = data?.sPID || this.$route?.query?.sPID || this.queryString?.sPID;
      this.sCurNodeID =
        data?.sCurNodeID || this.$route?.query?.sCurNodeID || this.queryString?.sCurNodeID;
      this.sCurLinkID =
        data?.sCurLinkID || this.$route?.query?.sCurLinkID || this.queryString?.sCurLinkID;
      this.initFlowBtns();
    }
  },
  methods: {
    isFunctionCode(code) {
      let rfunction = /^\s*function(\s+\w*)?\(.*\)\s*{/g;
      return rfunction.test(code);
    },
    execFunction(button, owner, v) {
      let code = [
        "var result= (" + v + ").call(this,data,button,owner,self);",
        "data=null;",
        "button=null;",
        "owner=null;",
        "self=null;",
        "return result;"
      ];
      let fn = new Function("data", "button", "owner", "self", code.join("\n"));
      let result = fn.call(this.$vm, this.local, button, owner, this);
      result = this.$replace(result, this.local);
      return result;
    },
    getButtonParams(button) {
      let owner = this.owner || this;
      let customParamHandler = {
        "system_datagrid_batch_delete":(v,button,pindex,value)=>{
          if(pindex === button.params.length - 1){
            return v;
          }else{
            return value;
          }
        }
      }
      let getValue = (v,button,pindex)=>{
        let obj = this.$expressParams(this.local);
        let value = this.$replace(v, obj) ;
        if(customParamHandler[button.actionName]){
          value = customParamHandler[button.actionName](v,button,pindex,value);
        }
        return value;
      }
      let params = _.fill(new Array(button.params.length), null);
      _.each(button.params, (p, pindex) => {
        Object.defineProperty(params, pindex, {
          get: () => {
            let paramValue = null;
            if (dsf.type(p.value) == "string") {
              let v = p.value.trim();
              if (this.isFunctionCode(v)) {
                paramValue = this.execFunction(button, owner, v);
              } else {
                paramValue = getValue(v,button,pindex);
              }
            } else if (dsf.type(p.value) == "object") {
              if (p.value.type == "static") {
                let v = p.value.code;
                paramValue = getValue(v,button,pindex);
              } else if (p.value.type == "switch") {
                let v = this.local[p.value.code.field];
                let dict = p?.value?.code?.value || {};
                let value = dict[v] || "";
                paramValue = getValue(value, button, pindex);
              } else {
                let v = p.value.code;
                if (this.isFunctionCode(v)) {
                  paramValue = this.execFunction(button, owner, v);
                }
              }
            }
            if (paramValue == "" || dsf.isUnDef(paramValue)) {
              paramValue = p.default || null;
            }
            if (paramValue === "false") {
              paramValue = false;
            } else if (paramValue === "true") {
              paramValue = true;
            }
            return paramValue;
          },
          configurable: true,
          enumerable: true
        });
      });
      return params;
    },
    clickBeforeHandler(button, $event, response) {
      let eventName = button.actionBeforeName;
      if (eventName && this.$vm[eventName] && dsf.isFunction(this.$vm[eventName])) {
        let params = {
          owner: this.owner || this,
          data: this.local,
          _self: this,
          targetButton: button,
          response,
          execWindow: window // 如果是新开页面 并且不是设计器页面 则把 window传给 二开页面使用
        };
        let result = this.$vm[eventName](params, $event);
        if (dsf.isFunction(result.then)) {
          return result;
        }
        return Promise.resolve(result);
      }
      return Promise.resolve();
    },
    async clickHandler(button, $event, response) {
      if (this.isDesign) {
        return;
      }
      if (this.$isPreView) {
        dsf.layer.message("当前状态下按钮不可执行此操作", false);
        return;
      }
      if (!button.execing) {
        button.execing = true;
        try {
          if (button.disabled || this.isDesign) {
            return;
          }
          await this.execButtonAction(button, $event, response);
        } catch (error) {
          dsf.error(error);
        } finally {
          button.execing = false;
        }
      }
    },
    async buttonAction(button, $event, response) {
      if (button?.children && button.children.length > 0) return;

      let owner = this.owner || this;
      if (dsf.isUnDef(button.loading)) {
        this.$set(button, "loading", false);
      }
      //如果是系统按钮
      if (button.isSystem) {
        let [index, index2] = button?.uploadSuccessHandlerParamIndex || [];
        if (
          button.isUploadImportTemplate &&
          button?.params?.[index] &&
          button?.params?.[index]?.value?.code
        ) {
          let size = button.params?.[index2 + 2]?.value?.code;
          let width, height;
          if (size) {
            [width, height] = size.split(",");
          } else {
            [width, height] = ["620px", "auto"];
          }
          this.$openDialog({
            title: "导入",
            width,
            height,
            content: "importTemplateDownload",
            footerAlign: "center",
            params: {
              ids: button.params?.[index]?.value?.code,
              names: button.params?.[index2]?.value?.code,
              tips: button.params?.[index2 + 1]?.value?.code,
              button: button,
              owner: this
            },
            btns: []
          });
        } else {
          let handler = this.buttonHandler(button.actionName, this.client);
          let params = this.getButtonParams(button);
          if (handler && dsf.isFunction(handler)) {
            //系统按钮
            let param2 = {
              owner: owner,
              data: this.local,
              _self: this,
              targetButton: button,
              params: params
            };
            if (response) {
              param2.response = response;
            }
            await handler.call(this.$vm, param2, $event);
          }
        }
      } else {
        //自定义按钮
        let eventName = (this.emitPrefix ? this.emitPrefix + "-" : "") + button.actionName;
        let handler = owner.$listeners[eventName];
        if (handler) {
          if (dsf.isFunction(handler)) {
            let params = {
              owner: owner,
              data: this.local,
              _self: this,
              targetButton: button,
              execWindow: window // 如果是新开页面 并且不是设计器页面 则把 window传给 二开页面使用
            };
            if (response) {
              params.response = response;
            }
            await handler(params, $event);
          }
        } else {
          //通过动作名字直接找对应的页面中的函数
          let eventName = button.actionName;
          if (eventName && this.$vm[eventName] && dsf.isFunction(this.$vm[eventName])) {
            let params = {
              owner: owner,
              data: this.local,
              _self: this,
              targetButton: button,
              execWindow: window // 如果是新开页面 并且不是设计器页面 则把 window传给 二开页面使用
            };
            if (response) {
              params.response = response;
            }
            await this.$vm[eventName](params, $event);
          } else {
            this.$message("设置的动作名称" + eventName + "不存在或不是一个函数", false);
          }
        }
      }
      button.execing = false;
    },
    execButtonAction(button, $event, response) {
      const { secondConfirm, secondConfirmText } = button;
      if (secondConfirm) {
        return dsf.layer.confirm({
          message: this.$replace(secondConfirmText || "确认提交？", this.local),
          dangerouslyUseHTMLString: true,
          closeOnClickModal: false
        }).then(() => this.buttonAction(button, $event, response))
      }
      return this.buttonAction(button, $event, response);
    },
    addFlowBtns(button, btns, index) {
      if (!btns && this.flowButtons.length > 0) {
        button.popVisible = !button.popVisible;
        setTimeout(() => {
          document.addEventListener("click", this.hidePopVisible);
        }, 0);
        return;
      }
      let sWFID;
      dsf.recursionComponentProps(this.$page.$props, (data) => {
        if (data.isFormControl && data.caption === "wfinfo") {
          sWFID = data.chooseFlow && data.chooseFlow.id;
        }
      });
      if (sWFID) {
        const param = {
          sWFID: sWFID,
          sPID: this.sPID,
          sCurNodeID: this.sCurNodeID,
          sCurLinkID: this.sCurLinkID,
          sExInfos: ""
        };
        this.getFlowBtns(param, button, btns, index);
      }
    },
    getFlowBtns(param, button, btns, index) {
      return this.$http
        .get("/wfr/getLines", {
          sWFID: param.sWFID,
          sPID: param.sPID,
          sCurNodeID: param.sCurNodeID,
          sCurLinkID: param.sCurLinkID,
          sExInfos: ""
        })
        .done((res) => {
          if (res.success && (res.data.Code >= 80000 && res.data.Code <= 90000)) {
            const data = res.data;
            const lines = data?.SendParams?.Lines?.filter(line => line.ccLine == 0 || dsf.isUnDef(line.ccLine));
            let lineBtns = [];
            if (lines) {
              lines.forEach((line) => {
                if (line.Name === "审核通过") {
                  line.order = 0;
                } else if (line.Name === "返回修改") {
                  line.order = 1;
                } else if (line.Name === "审核不通过") {
                  line.order = 2;
                } else {
                  line.order = 1;
                }
              });
              lines.sort((a, b) => a.order - b.order);
              lines.forEach((line, i) => {
                const newButton = Object.assign({}, button, {
                  caption: line.Name,
                  text: line.Name,
                  title: line.Name,
                  line: line
                });
                newButton.visible = button.flowVisible;
                delete newButton.flowVisible;
                this.hasFlowLinkSend = false;
                if (!btns) {
                  this.flowButtons.push(newButton);
                  this.$set(button, "popVisible", true);
                  document.addEventListener("click", this.hidePopVisible);
                } else {
                  // 重排页面
                  if (!dsf.global.$isMobile) {
                    setTimeout(() => {
                      newButton.style = {
                        width: "auto",
                        transform: "scale(1)"
                      };
                    }, 0);
                  }
                  btns.splice(index + i + 1, 0, newButton);
                  lineBtns.push(newButton);
                }
              });
              btns && btns.splice(btns.indexOf(button), 1);
            }
            this.$dispatch("getStepBtns", btns, lineBtns);
            return lineBtns;
          }
          return res.message;
        })
        .catch((res) => {
          return [];
        })
        .finally(() => {
          this.hasFlowLinkSend = false;
        });
    },
    // 流程类按钮
    hideFlowBtn(btn) {
      const actionName = btn.actionName;
      if (!this.sPID) {
        return ["system_flow_send","system_batch_flow_send","system_flow_openDialog","system_flow_changeHandler"].includes(actionName);
      }
      if (this.$vm?.flows?.flowCurInfo) {
        const flowCurInfo = this.$vm.flows.flowCurInfo;
        const processStatus = flowCurInfo.processstatus;
        const STATUS = flowCurInfo.STATUS;
        if (processStatus == 1) {
          if ([0, 1].includes(STATUS)) {
            return !['system_flow_recovery','system_flow_recoveryLink', 'system_flow_applyRecovery', 'system_flow_forceRecovery', 'system_flow_urge'].includes(actionName);
          } else if([2, -4].includes(STATUS)) {
            if (flowCurInfo.sendBack) {
              return "system_flow_situation" === actionName;
            }
            return ['system_flow_forceRecovery','system_flow_recovery','system_flow_situation'].includes(actionName);
          } else {
            return false;
          }
        } else {
          return actionName === "system_flow_situation";
        }
      }
      return true;
    },
    initFlowBtns() {
      let hasFlowBtn = false;
      let autoReceive = false;
      this.buttons.forEach((button, index) => {
        //将按钮执行状态设置为false
        button.execing = false;
        // 按钮是流程发送按钮或者是批量发送按钮 配置了分环节发送 设置了不折叠后需要加载
        let isLinkSend = button.isLinkSend;
        let isLinkSendFold = button.isLinkSendFold;
        let actionName = button.actionName;
        let sendButtons = ["system_flow_send", "system_batch_flow_send"];
        if (
          button.isSystem &&
          isLinkSend &&
          !isLinkSendFold &&
          sendButtons.indexOf(actionName) >= 0
        ) {
          // 为了解决ie显示一般问题
          if (dsf.client.type && dsf.client.type.indexOf("IE") > -1) {
            button.style = {
              transform: "scale(0.99)"
            };
          }
          // 存储按钮显示状态
          button.flowVisible = button.visible;
          this.hasFlowLinkSend = true;
          if (this.$form) {
            button.visible = false;
          }
          this.addFlowBtns(button, this.buttons, index);
        }
        // 表单中获取
        if (
          this.$form &&
          button.isSystem &&
          (actionName.indexOf("system_flow") > -1 || actionName.indexOf("system_batch_flow") > -1)
        ) {
          hasFlowBtn = true;
        }
        if (button.autoReceive) {
          autoReceive = true;
        }
      });
      // 如果有流程按钮 需要调用接口 自动签收 自动回收等操作
      if (hasFlowBtn) {
        dsf.flow.getLinkCurInfo(autoReceive, this);
      }
    }
  }
};
